import * as visit from "@/api/inspectionReport";

const state = {
  selectNakes: []
};

const mutations = {
  SET_selectNakes: (state, value) => {
    state.selectNakes = value;
  }
};

const actions = {
  list({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      visit
        .inspectionReport(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  //   valid({ commit }, dataParams) {
  //     return new Promise((resolve, reject) => {
  //       inspection
  //         .validationAdd(dataParams)
  //         .then(response => {
  //           resolve(response);
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //     });
  //   }
  //   add({ commit }, dataParams) {
  //     return new Promise((resolve, reject) => {
  //       visit.addStored(dataParams).then(response => {
  //         resolve(response)
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },
  //   getNakes({ commit }, dataParams) {
  //     return new Promise((resolve, reject) => {
  //       visit.dataNakes(dataParams).then(res => {
  //         const { data } = res.data;
  //         commit("SET_selectNakes", data);
  //         resolve(res);
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/inspectionReport.js